import React from 'react';
import { convertToSlug } from './helpers';

export const htmlSerializer = (type, element, content, children, key) => {
  if (['heading1', 'heading2', 'heading3'].includes(type)) {
    const id = convertToSlug(element?.text || '');
    const Tag = type.replace('heading', 'h'); // => h1, h2, h3
    return (
      <Tag key={key} id={id}>
        {children}
      </Tag>
    );
  }

  return null; // fallback to default render
};
